// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacapplymgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacapplymgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacapplymgrIconOutlined = function DrrpDacapplymgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacapplymgrIconOutlinedSvg
  }));
};

DrrpDacapplymgrIconOutlined.displayName = 'DrrpDacapplymgrIconOutlined';
export default React.forwardRef(DrrpDacapplymgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacapplymgrIconOutlined.js
// module id = 2504
// module chunks = 0